import * as React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ButtonComponent from 'src/components/ButtonComponent';
import { useNavigate } from 'react-router-dom';

interface Props {
  to: string;
}

const SeeMoreLink: React.FC<Props> = ({ to }) => {
  const navigate = useNavigate();
  return <ButtonComponent buttontype="righticon" icon={<ArrowForwardIcon />} text="See more" iconcolor="primary" onClick={() => navigate(to)} />;
};

export default SeeMoreLink;
